<template>
  <header class="dx-header">
    <div class="dx-header__wrapper">
      <router-link :to="{ name: 'newGame' }" class="dx-header__new-game">
        {{ $t('newGame') }}
      </router-link>
      <router-link :to="{ name: 'home' }" class="dx-header__logo">
        {{ $t('siteShortName') }}
      </router-link>
      <a href="#" class="dx-header__menu" @click.prevent="toggleMenu">
        {{ $t('menu') }}
      </a>
      <nav class="dx-header__nav">
        <ul class="list-inline">
          <li v-for="(item, index) in nav" :key="index">
            <router-link
              :to="{ name: item.link }"
              :class="item.class"
              v-if="showLink(item)"
              >
              {{ $t(item.label) }}
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'dx-header',
  methods: {
    toggleMenu () {
      this.$emit('toggle-menu')
    },
    showLink (item) {
      if (typeof item.auth !== 'undefined') {
        if (item.auth && !this.loggedIn) {
          return false
        } else if (!item.auth && this.loggedIn) {
          return false
        }
      }
      return true
    }
  },
  computed: {
    ...mapGetters({
      loggedIn: 'getLoggedIn',
      nav: 'getNav'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxHeader.vue